import { programsApi } from './api.js'
import type { Program } from '../types/index.js'

/** Demande explicitement l'accord de l'opérateur avant toute liaison automatique. */
export async function confirmSuggestedProgramMedia(programId: string, notifyWhenEmpty = false): Promise<Program | null> {
  const suggestions = await programsApi.mediaSuggestions(programId)
  const found = suggestions.filter(suggestion => suggestion.matches.length > 0)
  if (found.length === 0) {
    if (notifyWhenEmpty) {
      const expected = suggestions.map(suggestion => suggestion.expectedStem).filter(Boolean).join(', ')
      window.alert(expected
        ? `Aucun fichier correspondant trouvé sur le disque.\n\nNoms attendus : ${expected}`
        : 'Aucun fichier correspondant trouvé : le programme ne possède pas de code programme.')
    }
    return null
  }

  const unique = found.filter(suggestion => suggestion.matches.length === 1)
  const details = found.map(suggestion => {
    const names = suggestion.matches.map(match => match.fileName).join(', ')
    const suffix = suggestion.matches.length > 1 ? ' (plusieurs correspondances : aucune liaison automatique)' : ''
    return `Partie ${suggestion.partNumber} : ${names}${suffix}`
  }).join('\n')

  if (unique.length === 0) {
    window.alert(`Fichiers correspondants trouvés :\n\n${details}\n\nChoisissez le média manuellement pour lever l’ambiguïté.`)
    return null
  }
  if (!window.confirm(`Fichiers correspondants trouvés :\n\n${details}\n\nAssocier les correspondances uniques ?`)) {
    return null
  }

  return programsApi.confirmMediaSuggestions(programId, unique.map(suggestion => ({
    programId: suggestion.programId,
    filePath: suggestion.matches[0].filePath,
  })))
}
